/**
 * @brief   Fichier JS global à l'application
 */
import './bootstrap';
// Langue définie par défaut
window.lang = 'en';
// Nombre de secondes avant la fermeture d'un message
window.AUTOCLOSE_ALERT = 20;

/*
|--------------------------------------------------------------------------
| DEBUT DU FICHIER - NE RIEN AJOUTER D'AUTRE QUE require() AU DESSUS !
|--------------------------------------------------------------------------
*/

/**
 * @brief	Fonctionnalité réalisée à chaque changement de page.
 * @remark	Exploité notamment lors de la navigation dans l'historique.
 */
window.onload = window.onpageshow = function() {
	setTimeout(function() {
		// Masquage de l'activité de chargement après un petit délai
		document.getElementById('display-loading-activity').className = 'content invisible';
	}, 250);
};

/**
 * @brief   Fonctionnalités globales de l'application
 */
jQuery(document).ready(function() {

	//#####################################################
	// Get the lang attr from html
	//#####################################################
	window.lang = jQuery('html').attr('lang');

	/*
    |--------------------------------------------------------------------------
    | INITIALISATION DES REQUÊTES AJAX
    |--------------------------------------------------------------------------
    */

	// Initialisation des paramètres AJAX
	jQuery.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
		}
	});
	  
	/*
    |--------------------------------------------------------------------------
    | INITIALISATION DU SCROLL DANS LA PAGE
    |--------------------------------------------------------------------------
    */

	// Scroll to top
	jQuery(window).scroll(function() {
		if (jQuery(this).scrollTop() > 400) {
			jQuery('.top_button').fadeIn();
		} else {
			jQuery('.top_button').fadeOut();
		}
	});
	jQuery('.top_button').on('click', function() {
		jQuery('html').animate({scrollTop: 0}, 'slow');
		return true;
	});

	/*
    |--------------------------------------------------------------------------
    | INITIALISATION DU CONTRÔLE DU FORMAT NUMÉRIQUE DANS UN FORMULAIRE
    |--------------------------------------------------------------------------
    */

	// Verrouillage des champs numériques
	jQuery(document).on('keypress', 'input.numeric', function(event) {
		// Protection contre la saisie en cours
		event.stopPropagation();
		let keyPressed = event.keyCode || event.which;
		// Inhibition des caractères non numériques (clavier et pavé numérique)
		if (keyPressed > 20 && (keyPressed < 48 || keyPressed > 57)) {
			// Arrêt de la saisie
			event.preventDefault();
			return false;
		}
	});

	// Verrouillage des champs décimaux
	jQuery(document).on('keypress', 'input.decimal', function(event) {
		// Protection contre la saisie en cours
		event.stopPropagation();
		let content   = jQuery(this).val().toString();
		let dotExists = content.indexOf('\.') >= 0;
		let keyPressed = event.keyCode || event.which;
		// Inhibition des caractères non décimaux (clavier et pavé numérique)
		if (keyPressed > 20 && (keyPressed < 46 || keyPressed > 57) || (dotExists && keyPressed === 46) || keyPressed === 47) {
			// Arrêt de la saisie
			event.preventDefault();
			return false;
		}
	});

	// Verrouillage des champs téléphoniques
	jQuery(document).on('keypress', 'input.phone', function(event) {
		// Protection contre la saisie en cours
		event.stopPropagation();
		let keyPressed = event.keyCode || event.which;
		// Inhibition des caractères alphabétiques
		if (keyPressed > 20 && (keyPressed < 40 || keyPressed > 45) && (keyPressed < 48 || keyPressed > 57)) {
			// Arrêt de la saisie
			event.preventDefault();
			return false;
		}
	});

	// Verrouillage de la validation du formulaire avec la touche [Entrée]
	jQuery(document).on('keypress', 'input.no-submit', function(event) {
		// Protection contre la saisie en cours
		event.stopPropagation();
		let keyPressed = event.keyCode || event.which;
		// Inhibition de la touche [Entrée]
		if (keyPressed === 13) {
			// Arrêt de la saisie
			event.preventDefault();
			return false;
		}
	});

	/*
    |--------------------------------------------------------------------------
    | AFFICHAGE DE L'INDICATEUR DE CHARGEMENT DE LA PAGE
    |--------------------------------------------------------------------------
    */

	// Chargement de la page via les touches clavier
	jQuery(document).on('keydown', function(event) {
		// Protection contre les cliqueurs intempestifs
		event.stopPropagation();
		let keyPressed = event.keyCode || event.which;
		let ctrlPressed = event.ctrlKey;
		// Inhibition de la touche [F5] et [Ctrl]+[R]
		if (keyPressed === 116 || (ctrlPressed && keyPressed === 82)) {
			// Affichage de l'activité de chargement
			jQuery('#display-loading-activity').removeClass('invisible');
		}
	});

	// // Validation du formulaire
	// jQuery('form').on('submit', function(event) {
	// 	// Protection contre les cliqueurs intempestifs
	// 	event.stopPropagation();
	// 	// Affichage de l'activité de chargement
	// 	jQuery('#display-loading-activity').removeClass('invisible');
	// });

	// Navigation vers une page
	jQuery('a[href!="#"]:not([target=_blank])').on('click', function(event) {
		// Protection contre les cliqueurs intempestifs
		event.stopPropagation();
		// Fonctionnalité non réalisée si la touche [Ctrl] est appuyée (ouverture vers un autre onglet)
		if (!event.ctrlKey) {
			// Affichage de l'activité de chargement
			jQuery('#display-loading-activity').removeClass('invisible');
		}
	});

	// Masquage de l'activité de chargement à la fin du chargement
	jQuery('#display-loading-activity').addClass('invisible');

	/*
    |--------------------------------------------------------------------------
    | FERMETURE AUTOMATIQUE DES MESSAGES D'ALERTES
    |--------------------------------------------------------------------------
    */
	setTimeout(function() {
		// Message auto-fermant uniquement
		$('.auto-close').alert('close');
	}, window.AUTOCLOSE_ALERT * 1000);

	/*
    |--------------------------------------------------------------------------
    | /!\ ATTENTION : CE FICHIER EST DESTINÉ AUX FONCTIONNALITÉ GÉNÉRIQUES /!\
    |--------------------------------------------------------------------------
    | Les fichiers suivants sont destinés pour leurs pages respectives :
    | - Accueil      : /resouces/js/scripts/accueil.js
    | - Adresses     : /resouces/js/scripts/adresses.js
    | - Clients      : /resouces/js/scripts/clients.js
    | - Connexion    : /resouces/js/scripts/connexion.js
    | - Documents    : /resouces/js/scripts/documents.js
    | - ListeDePrix  : /resouces/js/scripts/listedeprix.js
    | - Soumissions  : /resouces/js/scripts/soumissions.js
    | - Utilisateurs : /resouces/js/scripts/utilisateurs.js
    | - Reinitialisation : /resouces/js/scripts/reinitialisation.js
    | Les fonctions JavaScript communes sont à mettre dans le dossier `functions`.
    | @see /resources/js/scripts/functions/*
    |
    | Les méthodes jQuery redondantes sont à exporter dans le dossier `jquery`.
    | @see /resources/js/scripts/jquery/*
    */

	// Méthodes jQuery communes
	require('./datatable/datatable.jquery');
	require('./scripts/jquery/navigation.jquery');
	/** DEBUT DU CODE JAVASCRIPT EN DESSOUS DE CETTE PARTIE ! */

	//#####################################################
	// Active MultiSelect
	//#####################################################
	$('.multiple-checkboxes').each(function() {
		$(this).multiselect({
			templates: {
				button: '<button type="button" class="multiselect dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><span class="multiselect-selected-text"></span></button>'
			},
			allSelectedText: false,
			nonSelectedText: ''
		});
	});

	/** FIN DU CODE JAVASCRIPT AU DESSUS DE CETTE PARTIE ! */
});
/*
|--------------------------------------------------------------------------
| FIN DU FICHIER - NE RIEN AJOUTER EN DESSOUS !
|--------------------------------------------------------------------------
*/
